import { ajax } from "../../utils";

const onClickLoadMoreExperiences = () => {
  let buttonLoadMoreExperiences = document.querySelector("#load-more-experiences");
  if (!buttonLoadMoreExperiences) return;

  buttonLoadMoreExperiences.addEventListener("click", () => {
      // add loading
      buttonLoadMoreExperiences.classList.add("loading");
      buttonLoadMoreExperiences.disabled = true;

      let formData = new FormData();
      formData.append("keyword", buttonLoadMoreExperiences.dataset.keyword);
      formData.append("page", buttonLoadMoreExperiences.dataset.page);

      ajax(
          buttonLoadMoreExperiences.dataset.url + "?" + new URLSearchParams(formData).toString(),
          (data) => {
              // remove loading
              buttonLoadMoreExperiences.classList.remove("loading");
              buttonLoadMoreExperiences.disabled = false;

              let container = document.querySelector("#container-experiences");
              container.insertAdjacentHTML("beforeend", data);
              buttonLoadMoreExperiences.dataset.page++;
              if (data.trim() === "") {
                  buttonLoadMoreExperiences.remove();
              }
          },
          "GET",
          formData,
          {
              "X-CSRF-Token": document.querySelector('meta[name="csrfToken"]')?.content,
          },
          true,
          false
      );
  });
};

export { onClickLoadMoreExperiences };
